import React from "react";
import PropTypes from "prop-types";
import { classNames } from "../../utils";

const ICON_NAME = /** @type { const } */ ([
  "checked",
  "uncheck",
  "triangle-up",
  "triangle-down",
  "arrow-right",
  "arrow-left",
  "arrow-down",
  "arrow-up",
  "arrow_up",
  "loading",
  "print",
  "pdf",
  "excel",
  "profile",
  "market_info",
  "performance",
  "historicaldata",
  "down-arrow",
  "up-arrow",
  "left-arrow",
  "right-arrow",
  "excel-icon",
  "print-icon",
  "checked-radio",
  "close-radio"
]);
/**
 *
 * @param {{
 * className: string,
 * name: import("../../..").ArrayToTuple<typeof ICON_NAME>
 * }} props
 */
export default function Icon({ name, className, extraPath, ariaLabel, ...props }) {
  return (
    <span {...props} className={classNames(`icon-${className}`)} aria-label={ariaLabel} >
      {extraPath}
    </span>
  );
}

Icon.propTypes = {
  name: PropTypes.oneOf(ICON_NAME),
  className: PropTypes.string,
  ariaLabel: PropTypes.string,
};
